import { render } from "./BaseTree.vue?vue&type=template&id=37153582&scoped=true&ts=true"
import script from "./BaseTree.vue?vue&type=script&lang=ts"
export * from "./BaseTree.vue?vue&type=script&lang=ts"

import "./BaseTree.vue?vue&type=style&index=0&id=37153582&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37153582"]])

export default __exports__